export default __webpack_public_path__ + "static/media/black-check.e8242698.svg";